import { NavLink } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { BOTTOM_NAV_ROUTES, NAV_ITEMS, filterByPermisos } from './navItems';

interface Props {
  onOpenMenu: () => void;
}

export function BottomNav({ onOpenMenu }: Props) {
  const { tiene } = useAuth();
  const visibles = filterByPermisos(NAV_ITEMS, tiene);
  const tabs = BOTTOM_NAV_ROUTES.map((r) => visibles.find((v) => v.to === r)).filter(
    (v): v is NonNullable<typeof v> => !!v,
  );

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-slate-200 flex"
      style={{ paddingBottom: 'var(--safe-bottom)' }}
    >
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center justify-center gap-0.5 py-2 min-h-[56px] text-[11px] transition
             ${isActive ? 'text-brand-600 font-semibold' : 'text-slate-500'}`
          }
        >
          <span className="text-xl leading-none">{t.icon}</span>
          <span className="truncate max-w-full px-1">{t.shortLabel ?? t.label}</span>
        </NavLink>
      ))}
      <button
        type="button"
        onClick={onOpenMenu}
        className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2 min-h-[56px] text-[11px] text-slate-500"
        aria-label="Más opciones"
      >
        <span className="text-xl leading-none">⋯</span>
        <span>Más</span>
      </button>
    </nav>
  );
}
